/**
 * teleop-logs/scroll — framework-free scroll helper for the log panels.
 * INTERNAL module file (not re-exported through index.ts).
 */

export interface ScrollableElement {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
}

export function isNearScrollBottom(el: ScrollableElement, threshold = 48): boolean {
  if (!el) return true;
  const { scrollTop, clientHeight, scrollHeight } = el;
  return scrollHeight - scrollTop - clientHeight < threshold;
}
